(() => {
  if (typeof window.customElements.get('products-with-media') !== 'undefined') {
    return;
  }

  window.customElements.define(
    'products-with-media',
    class ProductsWithMedia extends HTMLElement {
      constructor() {
        super();

        this.carousel = this.querySelector('[data-products-with-media-carousel]');
        this.swiper = null;
        this.resizeHandler = null;

        this.initProductsWithMedia();
      }

      initProductsWithMedia() {
        try {
          this.setupSwiper();
          this.setupResizeListener();
        } catch (error) {
          console.error('There was a problem with the ProductsWithMedia component:', error);
        }
      }

      setupResizeListener() {
        let resizeTimeout;
        this.resizeHandler = () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            this.handleResize();
          }, 250);
        };

        window.addEventListener('resize', this.resizeHandler);
      }

      handleResize() {
        const isMobile = window.innerWidth <= 749;

        if (isMobile && !this.swiper) {
          this.setupSwiper();
        } else if (!isMobile && this.swiper) {
          this.destroySwiper();
        }
      }

      destroySwiper() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      setupSwiper() {
        if (!this.carousel) {
          return;
        }

        if (this.carousel.dataset.productsWithMediaCarousel == 'false') {
          return;
        }

        if (window.innerWidth > 749) {
          return;
        }

        if (this.swiper) {
          return;
        }

        this.swiper = new Swiper(this.carousel, {
          slidesPerView: 'auto',
          spaceBetween: 10,
          centeredSlides: false,
          loop: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
        });

        return this.swiper;
      }

      disconnectedCallback() {
        if (this.resizeHandler) {
          window.removeEventListener('resize', this.resizeHandler);
        }
        this.destroySwiper();
      }
    }
  );
})();
